<script>
  import SignUpComponent from "$lib/Login/SignUpComponent.svelte";
</script>

<svelte:head>
  <title>Sign up — SmartClaim</title>
  <meta
    name="description"
    content="Create your SmartClaim account and start writing faster, more robust R&D tax credit narratives with AI built for UK tax advisors."
  />
  <link rel="canonical" href="https://smartclaim.uk/signup" />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://smartclaim.uk/signup" />
  <meta property="og:title" content="Sign up — SmartClaim" />
  <meta
    property="og:description"
    content="Create your SmartClaim account and start writing faster, more robust R&D tax credit narratives with AI built for UK tax advisors."
  />
</svelte:head>

<SignUpComponent />
